<template>
  <div class="form-group"
       :class="[
       {'input-group': hasIcon},
       {'has-right-slot': addonRightIcon || this.$slots.addonRight},
       {'has-error': error},
       {'input-group-focus': focused},
       {'has-label': label || $slots.label},
       {'has-success': !error && touched && hadError}]">
    <slot name="label">
      <label v-if="label" :class="labelClasses">
        {{label}}
        <span v-if="required">*</span>
      </label>
    </slot>

    <span v-if="addonLeftIcon || $slots.addonLeft" class="input-group-addon input-group-prepend">
      <slot name="addonLeft">
        <i :class="addonLeftIcon"></i>
      </slot>
    </span>
    <slot>
      <input
        v-if="!isTextArea"
        :value="value"
        v-on="listeners"
        v-bind="$attrs"
        class="form-control"
        v-price="price"
        :type="type"
        :class="[{valid: value && !error}, inputClasses]"
        aria-describedby="addon-right addon-left">

      <textarea v-if="isTextArea"  
                :value="value"
                v-on="listeners"
                v-bind="$attrs"
                class="form-control "
                :class="[{valid: value && !error}, inputClasses]"
                aria-describedby="addon-right addon-left"
                :style="`max-height: ${rows * 2 * 40}px; min-height: ${rows * 40}px; height:40px`"
      ></textarea>

    </slot>
    <span v-if="addonRightIcon || $slots.addonRight" class="input-group-addon input-group-append">
      <slot name="addonRight">
        <i :class="addonRightIcon"></i>
      </slot>
    </span>

    <slot name="infoBlock"></slot>
    <slot name="helpBlock">
      <div class="text-danger invalid-feedback" style="display: block;" :class="{'mt-2': hasIcon}" v-if="error">
        <div v-for="(msg, index) in errorsMsg" :key="index" >
            {{msg}}
        </div>
      </div>
    </slot>
  </div>
</template>
<script>
  export default {
    inheritAttrs: false,
    name: 'fg-input',
    props: {
      required: Boolean,
      label: String,
      error: String,
      errorsMsg: Array,
      labelClasses: String,
      inputClasses: String,
      value: [String, Number],
      addonRightIcon: String,
      addonLeftIcon: String,
      type: String,
      price: { type: Boolean,  default: false },
      isTextArea: { type: Boolean,  default: false },
      rows: Number,
      capitalize: {type: Boolean, default: false}
    },
    data () {
      return {
        touched: false,
        focused: false,
        hadError: false
      }
    },
    computed: {
      listeners () {
        return {
          ...this.$listeners,
          input: this.updateValue,
          focus: this.onFocus,
          blur: this.onBlur
        }
      },
      hasIcon () {
        const {addonRight, addonLeft} = this.$slots
        return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined
      }
    },
    methods: {
      updateValue (evt) {
        let value = evt.target.value
        if (!this.touched && value) {
          this.touched = true
        }
        if( this.capitalize && value && value !== '' ){
          const capitalizeFirstLetter = s => s.charAt(0).toUpperCase() + s.slice(1) 
          value = capitalizeFirstLetter(value)
        }
        this.$emit('input', value)
      },
      onFocus (value) {
        this.focused = true
        this.$emit('focus', value)
      },
      onBlur (value) {
        this.focused = false
       
        this.$emit('blur', value)
      }
    },
    watch: {
      error (value) {
        if (value) {
          this.hadError = true
        }
      }
    }
  }
</script>
<style>
  .input-group.has-right-slot input{
    border-right: 0;
  }

</style>
